import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import PackageTraking from "../../../components/PackageTraking";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import AllUserComplete from "./AllUserComplete";
import CompletePackages from "./CompletePackages";
import OrderChats from "../../../components/common/orderChat/OrderChats";
import { collection, doc, onSnapshot, query, updateDoc, where } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { getShipmentDetails } from "../../Shipping/Integration/APIService";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPackage, setSelectedRequest } from "../../../store/commonSlice";
import { getShelfConsolidatedPackages } from "../../../helper/functions";

function ShippingComplete() {
  const dispatch = useDispatch();
  const { selectedPackage:packageActiveData,activeComponent } = useSelector((state) => state.common);
  const { open } = useContext(SidebarContext);
  const [userActiveData, setUserActiveData] = useState({});
  const [selectedFilters,setSelectedFilters]=useState({routePartnerId:"",warehouseId:""})
  const [filterOptions, setFilterOptions] = useState({
    routePartners: [],
    warehouses: [],
  });
  const userData = useSelector((state) => state.auth.value);

  const [activeContent, setActiveContent] = useState({
    component: "Actions",
    data: undefined,
  });

  const chatClickHandler = async (e, id, item) => {
    e.stopPropagation();
    setActiveContent({ component: "Chats", data: id });
    setUserActiveData(item);
  };

  const userClickHandler = async (id, item) => {
    console.log("user click handler", item);
    setActiveContent({ component: "Actions", data: id });
    let consolidatedPackDetails = {};
    if(item?.consolidationId){
       consolidatedPackDetails = await getShelfConsolidatedPackages([
        {
          key: "__name__",
          operator: "==",
          value: item?.consolidationId,
        }
      ]);
      console.log({...item,...consolidatedPackDetails},"consolidatedPackDetails15151");
      console.log(consolidatedPackDetails,"consolidatedPackDetails15151dafsdf");
    }
    setUserActiveData(item);
    dispatch(setSelectedPackage(null));
    dispatch(setSelectedRequest({...item,...consolidatedPackDetails}));
    // const data1 = await getShipmentDetails(userData?.easyShipApikey, item?.easyshipShipmentId, "");
    // console.log(data1?.shipment,"data1?.shipment");
    
    // if(data1?.shipment){
    //   const docRef = doc(
    //     db,
    //     "shipments",
    //     item?.id
    //   );
      
    //   updateDoc(docRef, {
    //     labelUrl:data1?.shipment?.shipping_documents?.[0]?.url,
    //     customerDeclaration:data1?.shipment?.shipping_documents?.[1]?.url,
    //     labelStatus:data1?.shipment?.label_state
    //   }).then(()=>{
    //     setUserActiveData({...item,labelUrl:data1?.shipment?.shipping_documents?.[0]?.url,
    //       customerDeclaration:data1?.shipment?.shipping_documents?.[1]?.url,labelStatus:data1?.shipment?.label_state});
    //     // const label = data1?.shipment?.shipping_documents?.[0]?.url;
    //     // const label1 = data1?.shipment?.shipping_documents?.[1]?.url;
    //     // label?toast.success('Shipping Label Updated Successfully !'):toast.error('Shipping Label is not ready yet !')
    //     // reloadDetails({labelUrl:label,customerDeclaration:label1});
    //   });
    // }
  };

  const packageClickHandler = async (id, item) => {
    setActiveContent({ component: "Actions", data: id });
    dispatch(setSelectedPackage(item));
  };

  const closeHistoryHandler = () => {
    setActiveContent({ component: "Actions", data: undefined });
  };

  const changeFilterHandler = (filter) => {
    setSelectedFilters((prev) => ({ ...prev, ...filter }));
    if (filter?.routePartnerId) {
      const querySnapshot = collection(db, "routePartnerMainAddress");

      const q = query(
        querySnapshot,
        where("routePartnerId", "==", filter.routePartnerId)
      );
      onSnapshot(q, async (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions((prev) => ({ ...prev, warehouses: arr }));
      });
    }
  };

  useEffect(() => {
    // handler();
    try {
      const querySnapshot = collection(db, "routePartners");
      const q = query(querySnapshot, where("isDeleted", "==", false));
      onSnapshot(q, (snapshot) => {
        const arr = [];
        snapshot.forEach((doc) => {
          arr.push({ ...doc.data(), id: doc.id });
        });
        setFilterOptions({ routePartners: arr, warehouses: [] });
      });
    } catch (err) {
      console.log(err, "err");
    }
  }, []);

  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.packageShipmentCreationDate
        ? new Date(
            packageActiveData?.packageShipmentCreationDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
    },
    {
      label: "Packing",
      date: packageActiveData?.preparedShipmentDate
        ? new Date(
            packageActiveData?.preparedShipmentDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
    },
    {
      label: packageActiveData?.packageShipmentRequestDate
        ? new Date(
            packageActiveData?.packageShipmentRequestDate?.seconds * 1000
          ).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "-",
      date: "-",
    },
    { label: "Done", date: "-" },
  ];

  console.log("userActiveData", userActiveData);
  // console.log("packageActiveData", packageActiveData);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <PageHeader pageTitle={"Shipping Complete"} selectedFilters={selectedFilters} filterOptions={filterOptions} changeFilterHandler={changeFilterHandler} />
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          borderTop: "1px solid #E5E5E8",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <AllUserComplete
              chatClickHandler={chatClickHandler}
              userClickHandler={userClickHandler}
              userActiveData={userActiveData}
              selectedFilters={selectedFilters}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            sx={{ borderLeft: "1px solid #E5E5E8" }}
          >
            <CompletePackages
              userActiveData={userActiveData}
              packageClickHandler={packageClickHandler}
              packageActiveData={packageActiveData}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              height: "86vh",
            }}
          >
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "86vh" }}
              className="custom-scrollbar"
            >
              {activeContent.component === "Chats" && (
                <OrderChats
                  userActiveData={userActiveData}
                  packageActiveData={userActiveData}
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeContent.component === "Actions" && (
                <PackageTraking
                  packageActiveData={packageActiveData}
                  userActiveData={userActiveData}
                  collection="shelfPackages"
                  shipmentCollection="prepareShipmentRequests"
                  steps={steps}
                  activeStep={3}
                  pageName="shippingComplete"
                  reloadDetails={(updatedData)=>{
                    setUserActiveData(prev=>({...prev,...updatedData}))
                  }}
                />
              )}
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ShippingComplete;
